module.exports = " <div class=\"brush-palette clearfix\"> <div v-for=\"(idx, brush) in state.AVAILABLE_BRUSHES\" class=\"palette-button brush-palette-item\" data-cmd=setBrush data-arg=\"{{ idx }}\"> <div class=\"brush-icon brush-icon-idx\" v-bind:style=\"{'background-position': brush.backgroundPosition}\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/palettes/Brushes.vue
// module id = 180
// module chunks = 2